import React, { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import { FxmsContentDashboardDialog } from "../windows/FxWindows";
import { FxResource } from "./../inputs/FxResource";
import { OpClass, AttrListEdit } from "./../datas/OpClass";
import { FxmsData } from "../datas/FxData";
import { FxDashEditInfo } from "./FxDashBoard";

/**
 * 기능 버튼
 * 개발자 : T/F팀
 * 개발년월 : 2022.11
 * @param {*} props 
 * @returns 
 */
export const FxOpButton = (props) => {

  const { fxUiGrpItem, editable } = props;
  const [menu, setMenu] = React.useState(null);

  useEffect(() => {

    if (fxUiGrpItem.attrObj) {

      // 메뉴가 설정되어 있으면 해당 메뉴를 보이기 위함

      const opClass = OpClass.getOpClass(fxUiGrpItem.attrObj.opId);
      let opObj = FxmsData.getOpObj(fxUiGrpItem.attrObj.opId);

      console.log("*** FxOpButton ***  opObj ", props, opObj);

      if (opObj) {

        let child = null;
        let text = fxUiGrpItem.attrObj.text ? fxUiGrpItem.attrObj.text : opObj.opName;

        if (editable) {

          child = <p>{text}</p>;

        } else if (opObj.uiCmptName === 'DASHBOARD') {

          child = <DashboardButton text={text} opObj={opObj} />;

        } else {
          child = <ContentButton dialogTitle={opObj.opTitle} text={text} opObj={opObj} >
            <FxResource menu={opObj} selectedData={FxmsData.user} />
          </ContentButton>;
        }

        setMenu(child);

      } else {
        setMenu(<FxDashEditInfo>메뉴를 선택하세요</FxDashEditInfo>);
      }

    } else {
      setMenu(<FxDashEditInfo>메뉴를 선택하세요</FxDashEditInfo>);
    }

    return () => {
    };
  }, [editable]);

  return (
    <>
      {menu}
    </>
  );


};


/**
 * 기능버튼 환경 값
 * 
 * @param {*} fxUiGrp 
 * @param {*} fxUiGrpItem 
 * @returns 
 */
export function FxOpButtonConfig(fxUiGrp, fxUiGrpItem) {

  const setList = new AttrListEdit("setting");
  setList.makeAttrSelect(10, "opId", "바로가기 메뉴", 300, "menu", {});
  setList.makeAttrText(20, "text", "바로가기 타이틀", 300);
  setList.makeAttrButton(30, "cmdAdd", "적용", 100, null, function (data) {
    FxmsData.updateUi(fxUiGrp, fxUiGrpItem, data);
  });

  return setList;
}

const ContentButton = props => {
  let { text, dialogTitle } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [children, setChildren] = useState(props.children);

  const openModal = () => {
    setModalOpen(true);
    setChildren({ ...children });
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    console.log("*** FxmsContentButton ***  props ", props);
  }, []);

  return (
    <>
      <Button className="FxmsContentButton" onClick={openModal} >{text}</Button>
      <FxmsContentDashboardDialog open={modalOpen} closeModal={closeModal} dialogTitle={dialogTitle}>
        <main>{props.children}</main>
      </FxmsContentDashboardDialog>
    </>
  );
}

const DashboardButton = props => {
  let { text, opObj } = props;

  const moveDashboard = () => {

    const uiGrpNo = opObj.getAttrValue("uiGrpNo", -1);
    console.log(uiGrpNo);
    if (uiGrpNo < 0) {
      alert("어떤 대시보드 화면인지 설정되지 않았습니다.")
    } else {
      localStorage.setItem("basUiGrpNo", uiGrpNo);
      document.location.href = "/";
    }
  };

  return (
    <>
      <Button className="FxmsContentButton" onClick={moveDashboard} >{text}</Button>
    </>
  );
}

export default FxOpButton;
